import { render } from "./SigningDocumentReader.vue?vue&type=template&id=6d97708d&scoped=true"
import script from "./SigningDocumentReader.vue?vue&type=script&lang=js"
export * from "./SigningDocumentReader.vue?vue&type=script&lang=js"

import "./SigningDocumentReader.vue?vue&type=style&index=0&id=6d97708d&scoped=true&lang=scss"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d97708d"]])

export default __exports__